export enum CfarHotelModalStep {
  LoadingCancellationPolicy,
  Details,
  Confirmation,
  CancellationInProgress,
  // note: it can be either Success or Fail
  Complete,
}
